import React from 'react'
import { Message } from 'rsuite'

export default function ErrorMessage({ error, ...props }) {
  if (error) {
    return <Message {...props} showIcon type="error" description={error.message} />
  }
  return null
}
